"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRAcceptLanguagePlugin = void 0;
class XHRAcceptLanguagePlugin {
    constructor(language) {
        this.name = this.constructor.name;
        this.language = language;
    }
    setLanguage(language) {
        this.language = language;
    }
    handleRequest(request) {
        //TODO configurable
        request.headers = Object.assign(Object.assign({}, request.headers), { 'accept-language': this.language });
        return Promise.resolve(request);
    }
}
exports.XHRAcceptLanguagePlugin = XHRAcceptLanguagePlugin;
//# sourceMappingURL=xhrAcceptLanguagePlugin.js.map